import { cn } from "@/lib/utils";

interface ObservabilitySidebarResizeRailProps {
  onMouseDown: (event: React.MouseEvent) => void;
}

const ObservabilitySidebarResizeRail = ({ onMouseDown }: ObservabilitySidebarResizeRailProps) => (
  <div
    data-sidebar="rail"
    data-slot="observability-sidebar-rail"
    className={cn(
      "group/sidebar-rail absolute inset-y-0 -right-[9px] z-30 hidden w-4 cursor-col-resize select-none bg-transparent sm:flex",
      "hover:bg-blue-100/50",
    )}
    onMouseDown={onMouseDown}
    role="separator"
    aria-orientation="vertical"
    aria-label="Resize observability sidebar"
    title="Drag to resize sidebar"
  >
    <div className="pointer-events-none absolute left-1/2 h-full w-px -translate-x-1/2 bg-gray-200 transition-all duration-150 group-hover/sidebar-rail:bg-blue-600" />
    <div className="pointer-events-none absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 opacity-0 transition-opacity duration-150 group-hover/sidebar-rail:opacity-100">
      <div className="mx-1 h-12 w-[6px] rounded-full bg-blue-500" />
    </div>
  </div>
);

export default ObservabilitySidebarResizeRail;
